import { render, staticRenderFns } from "./PopupContentRecipeFilters.vue?vue&type=template&id=210da57f"
import script from "./PopupContentRecipeFilters.vue?vue&type=script&lang=js"
export * from "./PopupContentRecipeFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports